export default __webpack_public_path__ + "static/media/AdobeStock_449308752.e4c40af4.jpg";